import { ReactNode } from 'react';
import dynamic from 'next/dynamic';

interface Props {
	children?: ReactNode;
}

export default function Layout({ children }: Props) {
	const Navbar = dynamic(() => import('./AppNav'));
	const Footer = dynamic(() => import('./AppFooter'));
	return (
		<>
			<Navbar />
			<div>{children}</div>
			<Footer />
		</>
	);
}
